import axios from 'axios'
import * as types from './types'

export default {
  [types.OPEN_NEW_DISCOUNT_COUPON_SIDEBAR]: ({ commit }, payload) => {
    commit(types.MUTATE_NEW_DISCOUNT_COUPON_SIDEBAR, { ...payload, visible: true })
  },
  [types.SAVE_DISCOUNT_COUPON]: ({}, payload) => {
    return axios
      .post("/api/discount_coupons", payload)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.GET_DISCOUNT_COUPON]: ({}, payload) => {
    return axios
      .get(`/api/discount_coupons/${payload}`)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.GET_APP_PAYMENT_RULES]: ({}) => {
    return axios
      .get(`/api/discount_coupons/app_payment_rules`)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.SEARCH_DISCOUNT_COUPONS]: ({commit}, payload) => {
    return axios
      .post(`/api/discount_coupons/search`, payload)
      .then((resp) => {
        commit(types.MUTATE_DISCOUNT_COUPONS_SEARCH_RESULT, resp.data);
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  [types.TOGGLE_DISCOUNT_COUPON_STATUS]: ({}, payload) => {
    return axios
      .patch(`/api/discount_coupons/status/${payload}`)
      .then((resp) => {
        return Promise.resolve(resp);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
}
